import React, { memo } from 'react';
import PropTypes from 'prop-types';
import ScoreDisplay from './ScoreDisplay';

const CategoryScores = ({ mainValues, comparisonValues, category, showComparison, t, usePreCalculatedData }) => {
    const categoryData = mainValues[category] || {};
    
    return Object.entries(categoryData).map(([year, value], k) => (
        <div key={`single-${category}-${year}-${k}`} className="anwsers">
            <div className='balas tooltip'>
                <ScoreDisplay
                    value={value}
                    comparisonValue={comparisonValues[category]?.[year]}
                    year={year}
                    showComparison={showComparison}
                    t={t}
                />
            </div>
        </div>
    ));
};

CategoryScores.propTypes = {
    mainValues: PropTypes.object.isRequired,
    comparisonValues: PropTypes.object.isRequired,
    category: PropTypes.string.isRequired,
    showComparison: PropTypes.bool.isRequired,
    t: PropTypes.func.isRequired
};

export default memo(CategoryScores);
